// extracted by mini-css-extract-plugin
module.exports = {"silver":"#878787","copyrightStatement":"CopyrightStatement_copyrightStatement__B1Lqm"};